<router-outlet></router-outlet>

<ng-template #tplContent>
  <div class="ant-notification-notice-content">
    <div class="ant-notification-notice-with-icon">
          <span class="ant-notification-notice-icon">
            <i nz-icon nzType="info-circle" nzTheme="outline"></i>
          </span>
      <div class="ant-notification-notice-message">{{'NOTIFICATION.UPDATE.TITLE' | translate}}</div>
      <div class="content">
        <button class="refresh-button" (click)="reload()" nz-button nzType="link">
          <i nz-icon nzTheme="outline" nzType="reload"></i>
          {{'NOTIFICATION.UPDATE.CONTENT' | translate}}
        </button>
      </div>
    </div>
  </div>
</ng-template>
